var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticStyle:{"margin-right":"0.75rem"},attrs:{"pressed":_vm.pressed,"variant":"link"},domProps:{"innerHTML":_vm._s(_vm.buttonText)},on:{"click":_vm.toggleRoute}})
}
var staticRenderFns = []

export { render, staticRenderFns }